import styled from 'styled-components'

import { ColorAbr } from 'services/apiTypes/card.types'

const scryfallUrl = (filename: string | number) => `https://svgs.scryfall.io/card-symbols/${filename}.svg`
const getWidth = (symbol: string | number, width?: string) => {
  if (width) return width
  if (`${symbol}` === '1000000') return '4.9em'
  if (`${symbol}` === '100') return '1.8em'
  return '1em'
}

type ManaSymbolProps = {
  symbol: string | number | ColorAbr
  height?: string
  width?: string
  opacity?: number
  className?: string
}

export const ManaSymbol = ({ symbol, height = '1em', width = '1em', opacity = 1, className }: ManaSymbolProps) => {
  return (
    <div
      className={className}
      style={{
        backgroundImage: `url(${scryfallUrl(symbol)})`,
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        transition: 'all 0.2s ease-in-out',

        height,
        width: getWidth(symbol, width),

        opacity,
      }}
    />
  )
}

export const Slash = styled.div`
  display: inline-block;
  height: 1em;
  width: 1em;
  text-align: center;
`

export default ManaSymbol
